import { translateUi } from "@/shared/lib/ui-translate";

export const getStatusColor = (status: string) => {
  switch (status) {
    case "active":
      return "bg-red-500";
    case "draft":
      return "bg-blue-500";
    case "completed":
      return "bg-gray-500";
    case "cancelled":
      return "bg-muted-foreground";
    default:
      return "bg-gray-500";
  }
};

export const getStatusText = (status: string) => {
  switch (status) {
    case "draft":
      return translateUi("litTournamentUtils.chernovik");
    case "active":
      return translateUi("litTournamentUtils.idet");
    case "completed":
      return translateUi("litTournamentUtils.zavershen");
    case "cancelled":
      return translateUi("litTournamentUtils.otmenen");
    default:
      return translateUi("litTournamentUtils.neizvestno");
  }
};
